// extracted by mini-css-extract-plugin
export default {"slider":"Carousel_slider__eA6UN","img":"Carousel_img__k02EA"};